import React from 'react'
import { useStoreState, useStoreActions } from 'easy-peasy'
import { FormGroup, FormText } from 'reactstrap'
import styled from 'styled-components'
import ErrorMessage from './ErrorMessage'
import LabelCustom from './LabelCustom'
import InputCustom from './InputCustom'

const HelpText = styled(FormText)`
  display: flex;
  padding-top: 6px;
`

export default function File({ name }) {
  const [
    { label, placeholder, validate },
    error,
  ] = useStoreState(state => [
    state.form.getByName(name),
    state.form.getErrorByName(name),
  ])
  const [setInputValue] = useStoreActions(actions => [
    actions.form.setInputValue,
  ])
  return (
    <FormGroup className="col-xs-12">
      <LabelCustom htmlFor={`text-${name}`}>
        {label} {validate && validate.presence && <>*</>}
      </LabelCustom>
      <InputCustom
        id={`text-${name}`}
        name={name}
        type="file"
        style={{ marginTop: '40px' }}
        placeholder={placeholder}
        onChange={({
          currentTarget: {
            files: [value],
          },
        }) => {
          setInputValue({ name, value })
        }}
      />
      <HelpText color="muted">{placeholder}</HelpText>
      <ErrorMessage error={error} id={`error-${name}`} />
    </FormGroup>
  )
}
